"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.TextFieldProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _forms = require("../utils/forms");

var _core = require("@material-ui/core");

var _excluded = ["dataQa", "id", "type", "inputComponent", "autoComplete", "rows", "size", "margin", "multiline", "label", "keyboard", "placeholder", "required", "disabled", "variant", "startAdornment", "endAdornment", "InputProps", "InputLabelProps", "minDate", "maxDate"];

var styles = function styles(theme) {
  return {
    emptyTextUtil: {
      '&::before': {
        content: '""',
        display: 'inline-block'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
var keyboardInputModes = {
  number: 'numeric'
};
var keyboardPatterns = {
  number: '[0-9]*'
};

var TextField = function TextField(_ref) {
  var dataQa = _ref.dataQa,
      id = _ref.id,
      type = _ref.type,
      inputComponent = _ref.inputComponent,
      autoComplete = _ref.autoComplete,
      rows = _ref.rows,
      size = _ref.size,
      margin = _ref.margin,
      multiline = _ref.multiline,
      label = _ref.label,
      keyboard = _ref.keyboard,
      placeholder = _ref.placeholder,
      required = _ref.required,
      disabled = _ref.disabled,
      variant = _ref.variant,
      startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment,
      InputProps = _ref.InputProps,
      InputLabelProps = _ref.InputLabelProps,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles();

  var _useFormState = (0, _useFormState2["default"])(props),
      _onBlur = _useFormState.onBlur,
      name = _useFormState.name,
      _onChange = _useFormState.onChange,
      helperText = _useFormState.helperText,
      value = _useFormState.value,
      error = _useFormState.error,
      helpers = _useFormState.helpers; // If the value is null we don't want to pass the value
  // prop. This lets the input hold its own state


  var val = typeof value !== 'undefined' ? {
    value: value || ''
  } : {};
  var guaranteedID = id !== null && id !== void 0 ? id : "".concat(name, "-").concat(Date.now());
  return /*#__PURE__*/_react["default"].createElement(_core.TextField, (0, _extends2["default"])({
    id: guaranteedID,
    fullWidth: true,
    size: size,
    margin: margin,
    variant: variant
  }, val, {
    name: name,
    autoComplete: autoComplete,
    type: type,
    label: label,
    error: error,
    required: required,
    disabled: disabled,
    multiline: multiline,
    rows: rows // Ensure that there is always room in the layout for helper text
    ,
    helperText: helperText || /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.emptyTextUtil
    }),
    placeholder: placeholder,
    onChange: function onChange(event) {
      return _onChange && _onChange(event, event.target.value);
    },
    onBlur: function onBlur(ev) {
      return (0, _forms.trackOnBlur)(ev, _onBlur, name);
    },
    InputLabelProps: (0, _extends2["default"])({
      htmlFor: guaranteedID
    }, InputLabelProps),
    InputProps: (0, _extends2["default"])({
      startAdornment: startAdornment && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "start"
      }, startAdornment),
      endAdornment: endAdornment && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "end"
      }, endAdornment),
      inputComponent: inputComponent
    }, InputProps, {
      inputProps: (0, _extends2["default"])({
        'aria-describedby': id && "".concat(id, "-helper-text"),
        inputMode: keyboardInputModes[keyboard],
        pattern: keyboardPatterns[keyboard],
        'data-qa': dataQa,
        min: minDate,
        max: maxDate,
        onInvalid: function onInvalid(e) {
          e.preventDefault();
          helpers && helpers.setError(e.target.validationMessage);
        }
      }, InputProps.inputProps)
    })
  }));
};

var TextFieldProps = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** Field type */
  type: _propTypes["default"].oneOf(['text', 'password', 'date', 'email', 'search', 'tel']),

  /** Autocomplete hint */
  autoComplete: _propTypes["default"].oneOf(['bday', 'name', 'email', 'tel', 'current-password', 'new-password', 'street-address', 'address-level1', 'address-level2', 'postal-code']),

  /** Content to be shown before the input */
  startAdornment: _propTypes["default"].node,

  /** Content to be shown after the input */
  endAdornment: _propTypes["default"].node,

  /** Props passed to the underlying input */
  InputProps: _propTypes["default"].object,

  /** The identifier for this component. Required for testing and screen-readers. */
  id: _propTypes["default"].string,

  /** Name of the input. */
  name: _propTypes["default"].string,

  /** Value of the input. */
  value: _propTypes["default"].string,

  /** Label for the input. */
  label: _propTypes["default"].node.isRequired,

  /** Keyboard type to be used for text entry. */
  keyboard: _propTypes["default"].oneOf(['number', 'text']),

  /** Changes the visual style of the component */
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),

  /** Subtle text inside the field before value is input. */
  placeholder: _propTypes["default"].string,

  /** If `true`, this field has an error. */
  error: _propTypes["default"].bool,

  /** If `true`, this field is required. */
  required: _propTypes["default"].bool,

  /** If `true`, this field will be disabled */
  disabled: _propTypes["default"].bool,

  /** Text beneath the field used to prompt or to indicate errors. */
  helperText: _propTypes["default"].node,

  /** The size of the text field. */
  size: _propTypes["default"].string,

  /** If 'dense' or 'normal', will adjust vertical spacing of this and contained components. */
  margin: _propTypes["default"].oneOf(['dense', 'none', 'normal']),

  /**
   * Callback fired when the component is changed.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onChange: _propTypes["default"].func,

  /**
   * Callback fired when the component is unfocused.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onBlur: _propTypes["default"].func
};
exports.TextFieldProps = TextFieldProps;
TextField.defaultProps = {
  type: 'text',
  password: false,
  keyboard: 'text',
  InputProps: {},
  error: false,
  required: false,
  disabled: false,
  variant: 'outlined',
  size: 'medium',
  margin: 'none'
};
var _default = TextField;
exports["default"] = _default;